module.exports = __webpack_public_path__ + "img/circle-m.d5e26dcb.svg";